/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Attributes_StatusInputs */

const en_field_attributes_status = /** @type {(inputs: Field_Attributes_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes`)
};

/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Field_Attributes_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_attributes_status = /** @type {((inputs?: Field_Attributes_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Attributes_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_attributes_status(inputs)
});